var $f43313d21d3fd8e2$exports = {};
const { search: $f43313d21d3fd8e2$var$search, searchParams: $f43313d21d3fd8e2$var$searchParams } = new URL(document.location.href);
const $f43313d21d3fd8e2$var$referrer = $f43313d21d3fd8e2$var$search?.split("?")[1] || "";
const $f43313d21d3fd8e2$var$utm_source = $f43313d21d3fd8e2$var$searchParams.get("utm_source");
const $f43313d21d3fd8e2$var$userAgent = navigator.userAgent || navigator.vendor;
if (/android/i.test($f43313d21d3fd8e2$var$userAgent)) window.location.href = `https://play.google.com/store/apps/details?id=me.rainbow&referrer=${encodeURIComponent($f43313d21d3fd8e2$var$referrer)}`;
else if (/iPad|iPhone|iPod/i.test($f43313d21d3fd8e2$var$userAgent)) window.location.href = `https://apps.apple.com/app/apple-store/id1457119021${$f43313d21d3fd8e2$var$utm_source === "rainbowkit" ? "?pt=119997837&ct=rainbowkit&mt=8" : $f43313d21d3fd8e2$var$search}`;
else window.location.href = `https://rainbow.me/download${$f43313d21d3fd8e2$var$search}`;


//# sourceMappingURL=index.d618ec49.js.map
